<template>
  <v-card flat>
    <v-card>
      <v-toolbar color="primary" flat dark dense>
        <v-toolbar-title class="ml-2">Select the Timeframe for the Report</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <email-response-input
          v-model="reportInput"
          :show-campaign-select="false"
          :pre-selected-campaign-ids="seedCampaignIds"
        >
        </email-response-input>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="queryRunning"
          @click="generateReport"
          :dark="!queryRunning"
          color="primary"
          >Generate Report
          <v-icon class="pl-1">mdi-file-chart</v-icon>
        </v-btn>

<!--
        <v-btn
          :disabled="queryRunning"
          @click="downloadExcel"
          :dark="!queryRunning"
          color="green darken-4"
          >Download Excel Report
          <v-icon class="pl-1">mdi-cloud-download</v-icon>
        </v-btn>

        <v-btn
          :disabled="queryRunning"
          @click="downloadReport"
          :dark="!queryRunning"
          color="deep-purple darken-3"
          >Download Report Csv
          <v-icon class="pl-1">mdi-file-delimited</v-icon>
        </v-btn>
-->
      </v-card-actions>
    </v-card>
    <v-card class="mt-4">
      <v-sheet
        v-show="queryRunning"
        color="grey lighten-4"
        class="px-3 pt-3 pb-3"
      >
        <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
      </v-sheet>

      <email-response-report
        v-show="hasReportInput"
        v-bind="reportInput"
        :run-report="queryRunning"
        v-on:report-complete="onReportComplete"
        v-on:close-report="onReportClose"
        class="mt-4"
      ></email-response-report>
    </v-card>
  </v-card>
</template>

<script>
import EmailResponseInput from '@/components/reports/inputs/EmailResponseInput'
import EmailResponseReport from '@/components/reports/views/EmailResponseReport'
import { isEmpty } from 'ramda'

export default {
  name: 'conversion-stats-card',
  components: {
    [EmailResponseInput.name]: EmailResponseInput,
    [EmailResponseReport.name]: EmailResponseReport
  },
  props: {
    campaignId: {
      type: [String, Number],
      required: true
    },
    campaignName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      initialReport: EmailResponseInput,
      reportInput: { },
      outputFormat: null,
      queryRunning: false,
      showReport: false
    }
  },
  computed: {
    hasReportInput () {
      return !isEmpty(this.reportInput) && !this.queryRunning && this.showReport
    },
    seedCampaignIds () {
      return [parseInt(this.campaignId)]
    }
  },
  watch: {
    campaignId: function () {
      this.showReport = false
    }
  },
  methods: {
    onReportComplete (evt) {
      this.queryRunning = false
      if (evt.status === 'error') {
        this.$flash({
          showClose: true,
          message: `Error loading report: ${evt.message}`,
          type: 'error',
          duration: 0
        })
      }
    },
    onReportClose (evt) {
      this.showReport = false
    },
    generateReport () {
      this.queryRunning = true
      this.showReport = true
      this.$emit('input', Object.assign({}, this.reportInput, { outputFormat: 'html' }))
    },
    downloadReport () {
      this.showReport = false
      this.$emit('input', Object.assign({}, this.reportInput, { outputFormat: 'csv' }))
    },
    downloadExcel () {
      this.showReport = false
      this.$emit('input', Object.assign({}, this.reportInput, { outputFormat: 'excel' }))
    }
  }
}
</script>
